/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/suppliers'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import ForSuppliers from '@routes/ForSuppliers';

export const Route = createFileRoute('/suppliers')({
  component: () => <CacheDataRoute component={ForSuppliers} path='/suppliers' />
});
